import React, {useContext} from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { Chat as ChatIcon, Laptop } from "@mui/icons-material";
import { AuthContext } from "../context/AuthContext";
import { useBrand } from "../context/BrandContext";

const Placeholder = () => {
  const brand = useBrand();

  const theme = useTheme();
  const { userData } = useContext(AuthContext);

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="100%"
      bgcolor={theme.palette.background.default}
      color={theme.palette.text.primary}
      sx={{
        boxShadow:
          theme.palette.mode === "dark"
            ? "0 1px 4px rgba(0, 0, 0, 0.5)"
            : "0 1px 4px rgba(0, 0, 0, 0.1)",
      }}
      textAlign="center"
      p={3}
    >
      {/* Ícone */}
      <ChatIcon
        sx={{
          fontSize: 120,
          color: theme.palette.text.disabled,
          mb: 3,
        }}
      />

      {/* Mensagem Principal */}
      <Typography
        variant="h4"
        sx={{
          color: theme.palette.text.primary,
          fontWeight: "bold",
          mb: 2,
        }}
      >
        Selecione uma mensagem ao lado
      </Typography>

      {/* Mensagem Secundária */}
      <Typography
        variant="subtitle1"
        color={theme.palette.text.secondary}
        sx={{
          fontSize: "1.2rem",
          mb: 3,
          textAlign: "center",
        }}
      >
        {/* Nome com cor ajustada pelo tema */}
        <span
          style={{
            color: theme.palette.primary.main, 
            fontWeight: "bold",
          }}
        >
          {userData?.nome}
        </span>
        {/* Texto restante que adapta-se ao tema */}
        <span
          style={{
            color: theme.palette.text.primary,
          }}
        >
          , vamos melhorar a vida das pessoas?
        </span>
      </Typography>

      {/* Link */}
      <Typography
        variant="body2"
        sx={{
          color: theme.palette.text.disabled,
          fontSize: "0.9rem",
        }}
      >
        <Laptop
          sx={{
            marginRight: "2px",
            padding: 0,
            fontSize: "1rem",
            color: theme.palette.text.disabled,
          }}
        />{" "}
        Para mais informações sobre o {brand.name}{" "}
        <a
          href={brand.website}
          target="_blank"
          style={{
            color: theme.palette.primary.main, // Cor vinda do tema
            textDecoration: "underline",
            fontWeight: "bold",
          }} rel="noreferrer"
        >
          Clique aqui.
        </a>
      </Typography>
    </Box>
  );
};

export default Placeholder;
